import dynamic from "next/dynamic";

export const DynamicContent080 = dynamic(() => import("./Content080"), {
  suspense: true,
});
